import { render, staticRenderFns } from "./ChatbotsTemplate.vue?vue&type=template&id=5644ec45&scoped=true&"
import script from "./ChatbotsTemplate.vue?vue&type=script&lang=js&"
export * from "./ChatbotsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotsTemplate.vue?vue&type=style&index=0&id=5644ec45&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5644ec45",
  null
  
)

export default component.exports